import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'nombre',
    label: i18n('entities.habilidad.fields.nombre'),
    schema: schemas.string(
      i18n('entities.habilidad.fields.nombre'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'incluirEstadisticas',
    label: i18n('entities.habilidad.fields.incluirEstadisticas'),
    schema: schemas.boolean(
      i18n('entities.habilidad.fields.incluirEstadisticas'),
      {},
    ),
  },
];